exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.name-form[data-v-74228bc8] {\n  display: flex;\n}\n", ""]);

// exports
